export const ApplicationPaths = {
    Home: "/",
    SignIn: "login",
    SignOut: "logout",
    MfaSetup: "login-mfa-setup",
    MfaVerification: "login-mfa-verification",
};
